import { Store } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { translations } from "../../utils/translations/translations-manager";

let lastLanguage: 'it' | 'en';

export const languageChangeSubscription = (store: Store<RootState>) => {
  const state: RootState = store.getState();
  const language = state.auth.language;
  if (lastLanguage !== language) {
    translations.setLanguage(language);
    lastLanguage = language;
  }
}